export default "__VITE_ASSET__BE2fx$H___";